import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface PageHeaderProps {
  titleKey: string;
  subtitleKey: string;
  breadcrumbKey: string;
}

export default function PageHeader({ titleKey, subtitleKey, breadcrumbKey }: PageHeaderProps) {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-28 md:pt-36 pb-12 md:pb-16">
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
          <Link to="/" className="hover:text-primary-600 transition-colors">
            {t('footer.home')}
          </Link>
          <span className="flex w-4 h-4 items-center justify-center">
            <i className="ri-arrow-right-s-line text-sm"></i>
          </span>
          <span className="text-foreground-700">{t(breadcrumbKey)}</span>
        </nav>

        <h1 className="mt-6 text-2xl md:text-4xl font-heading font-extrabold text-foreground-950 leading-tight max-w-3xl">
          {t(titleKey)}
        </h1>
        <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
          {t(subtitleKey)}
        </p>
      </div>
    </section>
  );
}